import * as React from 'react';

import { IconProps } from '../IconProps';
import { SVGWrapper } from '../SVGWrapper';

export const NounIconChat: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style} viewBox="0 0 100 100">
        <path
            stroke="none"
            fill={color}
            d="M50.08,4.56h0M67.59,44.77a5.24,5.24,0,1,1-5,5.23,5.11,5.11,0,0,1,5-5.23ZM32.42,55.22A5.23,5.23,0,1,1,37.37,50v.1A5.09,5.09,0,0,1,32.42,55.22ZM54.94,50a5,5,0,1,1-5-5.25h0A5.17,5.17,0,0,1,55,50Z"
        />
        <path d="M50.08,4.56h0A41.83,41.83,0,0,0,26.54,11.9c-11.83,8-18.37,19.65-19.68,34.36a46,46,0,0,0,5.2,25.61,2.67,2.67,0,0,1,.29,1.33c-.36,2.93-.79,5.88-1.18,8.76-.44,3.32-.87,6.62-1.33,10.1l.87-.07c5.64-.82,11.26-1.64,17-2.43h.28a2.67,2.67,0,0,1,1.29.34,41.76,41.76,0,0,0,20.52,5.54,42.49,42.49,0,0,0,9.53-1.11C82.61,88.82,97.27,64.51,92,40,87.6,19.41,70.22,4.71,50.08,4.56" />
        <path stroke="none" fill={color} d="M45,50a5,5,0,1,0,5-5.23h0A5.16,5.16,0,0,0,45,50Z" />
        <path stroke="none" fill={color} d="M32.46,44.77a5.23,5.23,0,1,0,4.91,5.3h0a5.11,5.11,0,0,0-4.89-5.29Z" />
        <path stroke="none" fill={color} d="M67.55,55.23a5.24,5.24,0,1,0-5-5.26v0A5.12,5.12,0,0,0,67.55,55.23Z" />
    </SVGWrapper>
);
